<template>
  <div class="md-layout">
    <div
      v-for="(image, index) in images"
      :key="image.id"
      class="img-wrap"
      :class="[`md-size-${columnSize}`]"
    >
      <!-- //{{image.controlId}} -->
      <div
        class="image-content"
        :class="{
          error: image.error,
          'image-item': image.original && image.original.isRejected,
        }"
      >
        <span class="centered" v-if="image.original && image.original.isRejected">RECHAZADA</span>
        <md-button
          v-if="useFileIcons"
          @mouseenter="showIcons(index)"
          @click.stop="$emit('openLink', image, index)"
          :class="{
            active: image.error,
            rejected: image.original && image.original.isRejected,
          }"
          class="md-size-2x md-just-icon md-simple file-button"
        >
          <md-icon>{{ image.src | fileIcon }}</md-icon>
        </md-button>
        <img
          v-else
          v-lazy="image.thumb || image.src"
          :style="`max-height: ${imageHeight}px`"
          @mouseenter="showIcons(index)"
          @click.stop="openVisor(image, index)"
          :class="{
            active: image.error,
            rejected: image.original && image.original.isRejected,
          }"
        />
      </div>
      <span class="date-style" v-if="showLabels && image.label">{{ image.label }}</span>
      <span class="size-style text-gray" v-if="image.size !== undefined">{{ image.size | fileSize }}</span>
      <div v-if="imageActions" class="md-layout md-alignment-bottom-right">
        <slot
          name="image-actions"
          :isVisible="currentlyShow === index"
          :image="image"
          :index="index"
        >
          <template v-if="currentlyShow === index">
            <md-button
              class="md-primary md-just-icon md-round delete"
              @click.stop="deleteImage(image)"
            >
              <md-icon>delete</md-icon>
            </md-button>
            <md-button
              v-if="editEnabled"
              @click.stop="openEditorMdfck(image, index)"
              class="md-primary md-just-icon md-round edit"
            >
              <md-icon>edit</md-icon>
            </md-button>
          </template>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");

import usesAccountInfoMixin from "@/mixins/usesAccountInfo";
import fileIcon from "@/utils/fileIcon";

export default {
  mixins: [usesAccountInfoMixin],

  data() {
    return {
      hover: false,
      currentlyShow: null,
    };
  },

  props: {
    images: Array,
    imageActions: {
      type: Boolean,
      default: false,
    },
    editEnabled: {
      type: Boolean,
      default: true,
    },
    imageHeight: {
      type: Number,
      default: 128,
    },
    columnSize: {
      type: Number,
      default: 25,
    },
    showLabels: {
      type: Boolean,
      default: false,
    },
    useFileIcons: {
      props: Boolean,
      default: false,
    },
  },
  methods: {
    showIcons(index) {
      this.hover = true;
      this.currentlyShow = index;
    },
    // Interface Methods
    deleteImage(element, index) {
      this.$emit("delete", element, index);
    },
    openVisor(element, index) {
      this.$emit("openVisor", element, index);
    },
    openEditorMdfck(image, index) {
      this.$emit("edit", image, index);
    },
  },

  filters: {
    fileIcon: (file) => {
      const icon = fileIcon(file);
      return icon ? icon.icon : "picture";
    },
  },
};
</script>

<style lang="css" scoped>
.active {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  opacity: 0.6;
}
.error {
  box-shadow: 0px 0px 20px 5px red;
}
.rejected {
  box-shadow: 0px 0px 5px 5px rgb(255, 166, 0);
  opacity: 0.4;
}

.md-card {
  height: 120px;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
  width: 100%;
  margin: 15px 0;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
  overflow: unset;
  font-size: 0.875rem;
  box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  color: #333;
  background: #1111;
}

.img-wrap {
  position: relative;
  margin: 5px;
}
.img-wrap img {
  max-height: 100%;
  width: auto;
}

.md-button.md-fab,
.md-button.md-just-icon {
  padding: 0;
  overflow: hidden;
  line-height: 41px;
  position: absolute;
}

.delete {
  top: 2px;
  right: 2px;
}
.edit {
  top: 32px;
  right: 2px;
}

.image-item {
  position: relative;
  text-align: center;
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
  font-weight: 600;
  font-size: 25px;
}

.date-style {
  font-weight: bold;
  font-size: 1.5rem;
}

.size-style {
  display: block;
  font-size: 12px;
}

.md-button.md-just-icon.file-button,
.md-button.md-just-icon.file-button i {
  width: 96px;
  height: 96px;
  line-height: 96px;
  font-size: 96px !important;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Outputs/Images/Matrix.vue